/*! Isomorphic Style Loader | MIT License | https://github.com/kriasoft/isomorphic-style-loader */

'use strict';

var React = require('react');
var StyleContext = React.createContext({
  insertCss: null
});
module.exports = StyleContext;